/* Collection "products per row" toggle + sticky filter bar.
   - Applies the selected option to every product grid via data attributes and
     remembers the choice in localStorage. Works with infinite scroll (appended
     items inherit the grid) and facet AJAX (re-applied via observer).
   - There can be more than one toggle group on the page (the inline one in the
     filter row and the one inside the sticky bar); the selected option is keyed
     by its column descriptor so every group stays in sync.
   - Drives the sticky filter bar: slides up once the filter toolbar scrolls out
     of view, slides back down when the bottom of the product grid is reached. */
(function () {
  'use strict';

  var STORAGE_KEY = 'otay:grid-cols-v2'; // bumped to drop stale dev selections
  var DEFAULT_INDEX = 1; // middle option: mobile 2 / desktop 4

  // Canonical option order — matches snippets/collection-grid-toggle.liquid.
  var OPTIONS = [
    { mobile: '1', desktop: '3', imageOnly: false },
    { mobile: '2', desktop: '4', imageOnly: false },
    { mobile: '4', desktop: '8', imageOnly: true },
  ];

  // Show the sticky bar only after the toolbar is this far above the viewport.
  var STICKY_OFFSET = 175;

  function getButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.grid-toggle__btn'));
  }

  function getGrids() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-grid'));
  }

  function buttonIndex(button) {
    var mobile = button.getAttribute('data-cols-mobile');
    var desktop = button.getAttribute('data-cols-desktop');
    for (var i = 0; i < OPTIONS.length; i++) {
      if (OPTIONS[i].mobile === mobile && OPTIONS[i].desktop === desktop) {
        return i;
      }
    }
    return -1;
  }

  function readIndex() {
    var stored = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      stored = null;
    }
    var index = parseInt(stored, 10);
    if (isNaN(index) || index < 0 || index >= OPTIONS.length) return DEFAULT_INDEX;
    return index;
  }

  function saveIndex(index) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(index));
    } catch (e) {
      /* storage unavailable — selection just won't persist */
    }
  }

  function apply(index) {
    var option = OPTIONS[index] || OPTIONS[DEFAULT_INDEX];

    getGrids().forEach(function (grid) {
      grid.setAttribute('data-cols-mobile', option.mobile);
      grid.setAttribute('data-cols-desktop', option.desktop);
      if (option.imageOnly) {
        grid.setAttribute('data-image-only', 'true');
      } else {
        grid.removeAttribute('data-image-only');
      }
    });

    getButtons().forEach(function (btn) {
      btn.setAttribute('aria-pressed', buttonIndex(btn) === index ? 'true' : 'false');
    });
  }

  // Apply stored selection on load.
  apply(readIndex());

  // Handle clicks on any toggle button (delegated so it survives re-renders).
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.grid-toggle__btn');
    if (!button) return;

    var index = buttonIndex(button);
    if (index === -1) return;

    saveIndex(index);
    apply(index);
  });

  // Re-apply after facet AJAX swaps out the product grid.
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      apply(readIndex());
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  /* ---- Sticky filter bar ---- */

  var sticky = document.querySelector('[data-sticky-filter]');

  if (sticky) {
    // The sticky FILTER button opens the existing filter drawer/disclosure.
    var openTrigger = sticky.querySelector('[data-sticky-filter-open]');
    if (openTrigger) {
      openTrigger.addEventListener('click', function () {
        var summary = document.querySelector('.mobile-facets__wrapper summary');
        if (summary) summary.click();
      });
    }

    var toolbar = document.querySelector('.facets-wrapper');
    var ticking = false;

    var updateSticky = function () {
      ticking = false;
      var grid = document.querySelector('.product-grid');
      if (!toolbar || !grid) return;

      var toolbarBottom = toolbar.getBoundingClientRect().bottom;
      var gridBottom = grid.getBoundingClientRect().bottom;
      var viewport = window.innerHeight;

      // Visible once the toolbar has scrolled out of view (plus an offset),
      // and hidden again once the bottom of the grid comes into view.
      var scrolledPastToolbar = toolbarBottom < -STICKY_OFFSET;
      var reachedGridBottom = gridBottom <= viewport;
      var show = scrolledPastToolbar && !reachedGridBottom;

      sticky.classList.toggle('sticky-filter--visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    var requestSticky = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    };

    window.addEventListener('scroll', requestSticky, { passive: true });
    window.addEventListener('resize', requestSticky, { passive: true });
    updateSticky();
  }
})();
